import { Navigate, Outlet } from 'react-router'

import { isBillingEnabled } from '@/api/config'

/* the routes stay registered either way, so without this a prod user who types
 * /billing gets the full pricing table on a deploy where billing is dark. */
export function RequireBilling({ redirectTo = '/' }: { redirectTo?: string }) {
  if (!isBillingEnabled()) return <Navigate to={redirectTo} replace />
  return <Outlet />
}
